import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import ButtonLink from './ButtonLink';
import ContactLinks from './ContactLinks';
import SecondaryNav from './SecondaryNav';
import footerStyles from './footer.module.sass';

export default props => {
  const { footerProps } = props

  return (
    <footer className={footerStyles.footer}>
      <div className={footerStyles.content}>
        <div className={footerStyles.flex}>
          <h1 className={footerStyles.header}>{footerProps.header}</h1>
          <p className={footerStyles.body}>{footerProps.body}</p>
          <ButtonLink url={footerProps.booking_link} text="BOOK NOW" variant="default" addClass={footerStyles.buttonlink} />
        </div>
        <div className={footerStyles.businessinfo}>
          <ContactLinks addClass={footerStyles.contact} />
          <SecondaryNav addClass={footerStyles.secondarynav} />
        </div>
      </div>
    </footer>
  );
};